import React, { Component } from 'react';

class PathStopsMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Página de Paragens por percurso </h2>
                <p>
                    Nesta página encontra as paragens existentes numa linha e percurso selecionados.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar uma paragem numa linha e percurso selecionados</li>
                    <li>Editar a paragem de um percurso na rede ativa e na de rascunho</li>
                    <li>Eliminar paragens num percurso na rede ativa e na de rascunho</li>
                    <li>Comparar as paragens existentes num percurso na rede ativa com as da rede de rascunho </li>
                </ul>
            </div>
        );
    }
}

export default PathStopsMetadata;


// WEBPACK FOOTER //
// ./src/components/metadata/datamanager/PathStopsMetadata.js